import React from 'react';
import { motion } from 'framer-motion';
import { FolderOpen, ChevronRight } from 'lucide-react';
const indicators = ['📁 Más de 4.000 archivos', '📚 Biblioteca completa', '⭐ Categorías organizadas', '🔎 Fácil de navegar'];
export function Demo() {
  return <section className="py-14 px-6 bg-rose-light/10 overflow-hidden" data-id="element-77">
      <div className="max-w-5xl mx-auto" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-79">
          <h2 className="text-2xl md:text-4xl font-bold text-dark mb-3" data-id="element-80">
            TODO ORGANIZADO PARA ENCONTRAR LO QUE BUSCÁS EN{' '}
            <span className="italic text-rose-deep font-normal" data-id="element-81">SEGUNDOS</span>
          </h2>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 mt-6 mb-8" data-id="element-82">
            {indicators.map((ind, i) => <span key={i} className="bg-white px-4 py-1.5 rounded-full text-sm font-medium text-dark/80 shadow-sm border border-rose-light/30" data-id="element-83">
                {ind}
              </span>)}
          </div>
        </motion.div>

        <div className="relative max-w-3xl mx-auto" data-id="element-84">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-white rounded-2xl shadow-premium border border-rose-light/30 overflow-hidden" data-id="element-85">
            <div className="bg-cream/50 px-4 py-3 border-b border-rose-light/20 flex items-center gap-2" data-id="element-86">
              <div className="flex gap-1.5" data-id="element-87">
                <div className="w-3 h-3 rounded-full bg-rose-light" data-id="element-88"></div>
                <div className="w-3 h-3 rounded-full bg-gold-light" data-id="element-89"></div>
                <div className="w-3 h-3 rounded-full bg-green-200" data-id="element-90"></div>
              </div>
              <div className="ml-4 flex items-center text-xs text-dark/50 font-medium font-sans" data-id="element-91">
                <span data-id="element-92">Mi Unidad</span>
                <ChevronRight className="w-3 h-3 mx-1" data-id="element-93" />
                <span className="text-dark/80" data-id="element-94">La Biblia del Crochet</span>
              </div>
            </div>

            <div className="p-5 md:p-8" data-id="element-95">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-96">
                {[{
                name: '01. Amigurumis',
                count: '1,200+ archivos'
              }, {
                name: '02. Bebés y Niños',
                count: '850+ archivos'
              }, {
                name: '03. Tops y Blusas',
                count: '600+ archivos'
              }, {
                name: '04. Deco Hogar',
                count: '500+ archivos'
              }, {
                name: '05. Sweaters',
                count: '450+ archivos'
              }, {
                name: '06. Accesorios',
                count: '400+ archivos'
              }].map((folder, i) => <div key={i} className="flex items-center gap-3 p-3 rounded-xl border border-cream hover:bg-cream/30 transition-colors cursor-default" data-id="element-97">
                    <FolderOpen className="w-7 h-7 text-gold-dark/80 fill-gold-light/20" strokeWidth={1.5} data-id="element-98" />
                    <div data-id="element-99">
                      <h4 className="font-semibold text-dark text-sm" data-id="element-100">
                        {folder.name}
                      </h4>
                      <p className="text-xs text-dark/50" data-id="element-101">{folder.count}</p>
                    </div>
                  </div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}